export const headerColor = "#070432";
export const whiteColor = "#ffffff";
export const lightColor = "#E5E5E5";
export const lightSecondColor = "#ECEBFF";
export const lightThirdColor = "#ECECEC"
export const greyColor = "#F2EDE9";
export const greyDarkColor = "#313332";
export const greyLightColor = "#808080";
export const greyTextColor = "#BAB7DB";
export const greyAddColor = "#717171";
export const blackColor = "#050237";
export const orangeColor = "#FF9960";
export const orangeColorSecond = '#F07733'
export const orangePreLightColor = "#FFC6A6";
export const greenColor = "#5DB574";
export const orangeLightColor = "#F0DACD";
export const progressTitleColor = "#7F7E98";
export const questionTextColor = "#ECEBFF";
export const questionDarkTextColor = "#050237";
export const blueColor = "#172F88";
export const blueDarkColor = "#201D4E";
export const disabledColor = "#504E73";
export const darkColor = "#16125B";
export const slideBgColor = "#353078";
export const checkBoxPointColor = "#92837A";
export const purpleColor = "#4E4B6F";
export const purpleLightColor = "#7D79AA";
export const purpleSecondColor = "#5e5c7c";
export const buttonGradient =
  "linear-gradient(88.68deg, #FF8078 -6.71%, #F1AF61 105.98%);";
export const bgGradient =
  "radial-gradient(62.47% 62.7% at 11.73% 4.16%, #231D8E 0%, rgba(72, 79, 248, 0) 100%);";
export const greySecondColor = '#8B8990'
export const greyThirdColor = '#B0AFB2'
export const greyFourthColor = '#6C6C6C'
